

export const GET_CAR_VALUE_RANGE_DROPDOWN = 'GET_CAR_VALUE_RANGE_DROPDOWN';
export const GET_CAR_VALUE_RANGE_DROPDOWN_SUCCESS = 'GET_CAR_VALUE_RANGE_DROPDOWN_SUCCESS';
export const GET_CAR_VALUE_RANGE_DROPDOWN_ERROR = 'GET_CAR_VALUE_RANGE_DROPDOWN_ERROR';
// Query string for fetch (not DocumentNode)
const CAR_VALUE_RANGE_DROPDOWN_QUERY_STRING = `query CarValueRangeDropdown($listId: Int!) { CarValueRangeDropdown(listId: $listId) { id car_value_range recommended_excess policy_deductible selected } }`;

export function getCarValueRangeDropdown(listId) {
  return async (dispatch) => {
    dispatch({ type: GET_CAR_VALUE_RANGE_DROPDOWN });

    const response = await fetch("/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        query: CAR_VALUE_RANGE_DROPDOWN_QUERY_STRING,
        variables: {
          listId: Number(listId),
        },
      }),
    });
    try {
      const result = await response.json();
      const carValueRangeDropdown = result.data?.CarValueRangeDropdown || [];
      dispatch({
        type: GET_CAR_VALUE_RANGE_DROPDOWN_SUCCESS,
        payload: carValueRangeDropdown,
      });
      return carValueRangeDropdown;
    } catch (error) {
      dispatch({
        type: GET_CAR_VALUE_RANGE_DROPDOWN_ERROR,
        error: error.message,
      });
      return [];
    }
  };
}
